import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-pagos',
  templateUrl: './pagos.component.html',
  styleUrls: ['./pagos.component.css']
})
export class PagosComponent implements OnInit {

  public url;

  constructor(private sanitizer: DomSanitizer,
    private _userService: UserService) { }

  ngOnInit(): void {
    this.url = this._userService.GetsessionStorage('pse');
    console.log(this.url)
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
